import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { interval, Subject, Subscription, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BotCheckRequest } from 'src/app/class/BotCheckRequest';
import { SubSink } from '../../../node_modules/subsink';
import { AppConfigService } from '../app-config.service';
import { AccessDecision } from '../class/AutoLockAccess';
import { ResultContent } from '../class/AutoLockApiResponse';
import { AutoLockRequestModel } from '../class/AutoLockRequestModel';
import { DestinationDetails, DestinationDetailsForProtectedText } from '../class/DestinationDetails';
import { eventType } from '../class/eventType';
import { BrandDetails, CountryCodeDetails, EmailVefify, IBrandDetailsHF, ICountryCodeDetails, ICountryDialCodeForSenderAddress, IEmailVefifyHF, IRedactHF, Redact, RedactReply } from '../class/redact';
import { SendAccessControlNoticeRequestModel } from '../class/SendAccessControlNoticeRequestModel';
import { AppError } from '../common/class/app-error';
import { GuidGenerator } from '../common/class/guid-generator';
import { AccessDecisionService } from '../service/AccessDecisionService';
import { AutolockSessionStateService } from '../service/Autolock-session-state.service';
import { AI_AutoLock_Access_Check } from '../service/AutoLock_Access_Check/AI_AutoLock_Access_Check';
import { CryptoService } from '../service/CryptoService';
import { RedactReplyServiceService } from '../service/redact-reply-service.service';
import { SessionStateService } from '../service/session-state.service';

@Component({
  selector: 'app-protected-text',
  templateUrl: './protected-text.component.html',
  styleUrls: ['./protected-text.component.scss']
})
export class ProtectedTextComponent implements OnInit,AfterViewInit {

  mySubscription: Subscription;
  logoId: string;
  selectedLanguage: string;
  hideElement = false;
  isVerified = false;
  isSMSOptionEnabled: boolean = false;
  destShortURL: string;
  emailId: string;
  phoneNumber: string;
  countryCode: string;
  HeaderHtml: SafeHtml;
  public redact = new Redact;
  public emailVerfication = new EmailVefify;
  public brandDetails = new BrandDetails;
  public countryCodeDetails = new CountryCodeDetails;
  public filteredCountries: CountryCodeDetails[] = [];
  private subs = new SubSink();
  loginForm: FormGroup;
  loginFormSMS: FormGroup;
  public copied = false;
  showLogo: boolean = true;
  emailDispatchOption: number;
  companyLogoURL: string = "";
  countDown: Subscription;
  confidentialityStatement: string;
  counter: number;
  tick = 1000;
  subscription: Subscription;
  public arrayRedactData: Array<RedactReply>;
  DialCodeForSenderAddress: string;
  selectedDialCode: string;
  isAutoLock_AccessDenied: boolean;
  accessDeniedText: string;
  isDisappearInk: boolean;
  contactSenderText: string;
  productLine: string;
  private unsubscribe$ = new Subject<void>();
  approvedByPasscode: boolean;
  viewTextRefUrl: string;
  protectedRefUrl:string;
  featureType: string;
  themeValue: boolean;
  copyImage: string | null = null;
  destinationDetailsForProtectedText: DestinationDetailsForProtectedText = new DestinationDetailsForProtectedText();
  copyImages: string[] = [];
  ClipboardItem: any;
  ActiveTabsKey: any;
  detectionKey: any;
  OpenActiveTabsKey: any;
  OpendetectionKey: any;
  AutolockActiveTabsKey: any;
  AutolockDetectionKey: any;
  showAttachmentPane: boolean = false;
  subject: string;
  attachments: any[] = [];
  crypto: CryptoService;
  showAttachmentsBySetting: boolean = false;
  remainingTime: number = 0;
  isReplyOpen = false;
  isEsignOneClickReplyOpen: boolean = false;
  protectedEmailBody: SafeHtml = '';
  @ViewChild('messageSection', { static: false }) messageSection?: ElementRef;
  @ViewChild('replySection', { static: false }) replySection?: ElementRef;
  dynamicDivClass: string = ''
  showReplyButton: boolean = false;
  showAcceptReplyButton: boolean = false;

  deviceLogId: string = GuidGenerator.standard();
  isExpanded = true;
  IsDeviceFingerprintSettingEnabled: boolean = false;
   loading = true;              // Hide actual page
themeLoaded = false;         // Theme API completed
showSkeleton = false;        // Show skeleton only after theme is known

brandingLoaded = false;      // Branding API completed
destinationLoaded = false;
showContentLoader = false;
encryptedShortUrl="";
  constructor(private formBuilder: FormBuilder, private user: RedactReplyServiceService,
    private AI_Autolock_user: AI_AutoLock_Access_Check, private http: HttpClient,
    private router: Router, private route: ActivatedRoute
    , private translate: TranslateService, private location: Location, private accessDecisionService: AccessDecisionService, private sanitizer: DomSanitizer,
    private config: AppConfigService, private sessionState: SessionStateService, private AutolockSessionState: AutolockSessionStateService,
    private cdRef: ChangeDetectorRef, private snackBar: MatSnackBar) {
    this.protectedRefUrl = this.config.protectedRefUrl;
    this.crypto = new CryptoService();
    this.route.params.subscribe(params => {
      const shortURL: string = params.shortURL;

      if (shortURL && shortURL.endsWith('-pwd')) {
        console.log('Approved By Passcode');
this.encryptedShortUrl=shortURL;
        // Remove "-pwd"
        const encryptedValue = shortURL.substring(0, shortURL.length - 4);

        try {
          this.destShortURL = this.crypto.decryptQueryString(
            encryptedValue,
            this.config.preSetEncryptPwdKey,
            this.config.preSetEncryptPwdIVector
          );

          this.approvedByPasscode = true;
        } catch (e) {
          console.error('Decryption failed');
          this.approvedByPasscode = false;
          this.destShortURL = null;
        }
      } else {
        this.destShortURL = shortURL;
        this.approvedByPasscode = false;
      }
    });
    this.productLine = this.config.productLine;

  }
  ngAfterViewInit(): void {

  }
  public conditionvalue: number = 0;
 // emailPattern = "^[a-zA-Z0-9.!#_%'&^$?\\-/+=]*[a-zA-Z0-9.!#_%'&^$?\\-/+=]+@[a-zA-Z\\u0080-\\uFFFF0-9_-]+\\.[a-zA-Z]{2,4}(?:\.[a-zA-Z]{2})?$";
emailPattern = "^[a-zA-Z0-9.!#_%'&^$?\\-/+=]*[a-zA-Z0-9.!#_%'&^$?\\-/+=]+@(?:[a-zA-Z\\u0080-\\uFFFF0-9_-]+\\.)+[a-zA-Z]{2,}$";
 phoneNumberPattern = "^[0-9+\\- ]+$";

  ngOnInit() {
  //  this.loading = true;
  this.themeLoaded = false;
  this.showSkeleton = false;
  this.brandingLoaded = false;
  this.destinationLoaded = false;
  this.showContentLoader=false;

const storedTheme = localStorage.getItem('themeValue');

if (storedTheme) {

    this.themeValue = JSON.parse(storedTheme);

    // Show skeleton immediately
    this.loading = true;
    this.themeLoaded = true;
}
else{

    this.loading = true;
}

    // Initialize the destination details and result content objects
    // var destinationDetailsForProtectedText = new DestinationDetailsForProtectedText();
    var destDetails = new DestinationDetails();
    var resultContent = new ResultContent();
    // Detect client information
    this.detectClientInfo().then(clientInfo => {
      const { ipAddress, userAgent, referer, language } = clientInfo;
      console.log('Client Info:', ipAddress, userAgent, referer, language);
      const requestModel: BotCheckRequest = {
        IPAddress: ipAddress,
        ShortUrl: this.destShortURL,
        org: null,
        httpMethod: null,
        connection: null,
        httpUserAgent: null,
        secChUaModel: null,
        secChUaPlatform: null,
        msCv: null,
        Feature: 'Redact'
      };

      this.AI_Autolock_user.botCheck(requestModel).subscribe(result => {
        if (result == null || result.isBot) {
          window.location.href = 'about:blank';
          return;
        }

        // console.log('Skip Sending Alert:', result.skipSendingAlert);
        // console.log('Skip Reason:', result.skipReason);
        console.log('Is Bot:', result.isBot);
        this.getBrandingDetails();

        var isPassCodeVerified = localStorage.getItem('passcodeverified');
        if (isPassCodeVerified != null && isPassCodeVerified != undefined && isPassCodeVerified != "" && isPassCodeVerified == "true") {
          this.getRedactTextView();
          this.countDown = timer(0, this.tick)
            .subscribe(() => this.redact.TimeAllowed)
          this.mySubscription = interval(60000).subscribe((x => {
            if (this.redact.TimeAllowed > 0) {
              this.subs.sink = this.user.apiRedactTextViewDuration(this.logoId)
                .subscribe(resp => {

                });
            }
          }));
          this.isVerified = true;
          localStorage.setItem("passcodeverified", "false");
          this.cdRef.detectChanges();
        }
        // Get destination details independently
        this.featureType = 'Redact';
        this.user.getDestinationDetails(this.destShortURL, ipAddress, 'Redact')
          //.pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            destinationDetailsForProtectedText => {
              this.destinationDetailsForProtectedText = destinationDetailsForProtectedText;
              if (destinationDetailsForProtectedText == null)
                return;

              var destinationDetails = destinationDetailsForProtectedText.DestinationDetails;

              if (destinationDetails != null && destinationDetails != undefined
                && (destinationDetails.emailBody == '' || destinationDetails.emailBody == null || destinationDetails.emailBody == undefined)) {
                const decodedHtml = this.decodeBase64Utf8(this.destinationDetailsForProtectedText.EmailBody || '');
                destinationDetails.emailBody = decodedHtml;
                var html = this.getSafeHtml(decodedHtml);
                this.protectedEmailBody = html;
              }

              if (destinationDetails) {
                destDetails.MessageId = destinationDetails.MessageId;
                destDetails.DestinationAddress = destinationDetails.DestinationAddress;
                destDetails.SenderAddress = destinationDetails.SenderAddress;
                destDetails.MessageLanguage = destinationDetails.MessageLanguage;
                destDetails.MessageSubject = destinationDetails.MessageSubject;
                destDetails.MessageCategory = destinationDetails.MessageCategory;
                destDetails.MessageCreatedDate = destinationDetails.MessageCreatedDate;
                destDetails.EMailDispatchOption = destinationDetails.EMailDispatchOption;
                destDetails.DestinationName = destinationDetails.DestinationName
                destDetails.PhoneNumber = destinationDetails.PhoneNumber; //S1-3032
                // this.showAttachmentsBySetting = destinationDetails.ProtectedMsgShowAttachments;
                this.user.getAttachments(this.destShortURL).subscribe({
    next: (res: any[]) => {
      this.attachments = res || [];
      console.log('Attachments response:', this.attachments);
    },
    error: (err) => {
      console.error('Attachment load error:', err);
      this.attachments = [];
    }
  });
                this.translate.use(destDetails.MessageLanguage);
                localStorage.setItem('Langauge', destDetails.MessageLanguage);
                this.protectedRefUrl = this.protectedRefUrl.replace('{shortURL}', this.destShortURL);
                this.showReplyButton = destinationDetails.ProtectMsgReplyEnabled != null
                  && destinationDetails.ProtectMsgReplyEnabled
                  && destinationDetails.IsProtectedReply != null && !destinationDetails.IsProtectedReply
                  && destinationDetails.ProtectMsgReplyLimit > 0;
                this.showAcceptReplyButton = destinationDetailsForProtectedText.DestinationDetails.EsignType == 2
                  && (destinationDetailsForProtectedText.DestinationDetails.IsSigned == null
                    || destinationDetailsForProtectedText.DestinationDetails.IsSigned == 0);
                this.IsDeviceFingerprintSettingEnabled = destinationDetails.DeviceFingerprintSetting;
                if (!this.approvedByPasscode && (destinationDetails.RequestStatus != 2) && !destinationDetails.IsExpired) {
                  // Prepare auto lock request model
                  const autoLockRequest: AutoLockRequestModel = {
                    IpAddress: ipAddress,
                    // IpAddress: "54.193.115.33",
                    SenderAddress: destDetails.SenderAddress,
                    RecipientAddress: destDetails.DestinationAddress != null ? destDetails.DestinationAddress : " ",
                    //ProductLine: "RMail",
                    ProductLine: this.productLine,
                    ProductFeature: this.featureType,
                    ReferenceId: destDetails.MessageId,
                    Http_UserAgent: userAgent,
                    HTTP_Referer: referer,
                    Browser_Language: language,
                    RecipientType: destDetails.EMailDispatchOption == 2 ? 1 : 0,  //S1-3032
                    RecipientMobile: destDetails.DestinationName + " <" + destDetails.PhoneNumber + ">",
                    TransactionDate: destinationDetails.MessageCreatedDate,
                    AuditTrail: null,
                    Subject: destinationDetails.MessageSubject,
                    RecipientName: destinationDetails.DestinationName,
                    HttpMethod: null,
                    Language: destDetails.MessageLanguage,
                    IsPrimeEnvironment: !this.productLine || this.productLine.toLowerCase() !== 'rmail'
                  };

                  //Call auto lock access check
                  this.AI_Autolock_user.getautoLockAccess(autoLockRequest)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe(
                      autoLockResponse => {
                        if (autoLockResponse && autoLockResponse.resultContent) {
                          resultContent = autoLockResponse.resultContent;
                          if (
                            resultContent &&
                            resultContent.autoLockRiskAnalysisData &&
                            resultContent.autoLockRiskAnalysisData.isBot === true
                          ) {
                            return null;
                          }
                          if (resultContent.lock) {
                            // Prepare access control notice request model
                            const accessControlNoticeRequest: SendAccessControlNoticeRequestModel = {
                              SenderAddress: destDetails.SenderAddress,
                              RecipientAddress: destDetails.EMailDispatchOption == 2 ? destDetails.DestinationName + " <" + destDetails.PhoneNumber + ">" : destDetails.DestinationAddress,
                              MessageId: destDetails.MessageId,
                              Location: `${resultContent.city}, ${resultContent.regionCode}`,
                              Country: resultContent.countryName,
                              Network: resultContent.network,
                              Feature: "RMail - Redact",
                              OriginalSentDate: destDetails.MessageCreatedDate,
                              IpAddress: ipAddress,
                              ContinentCode: resultContent.continentCode,
                              AlertType: resultContent.riskLevel === 'Y' ? 'Yellow' : 'Red',
                              Language: destDetails.MessageLanguage,
                              Subject: destDetails.MessageSubject,
                              UserAgentRiskTextCode: resultContent.autoLockRiskAnalysisData.userAgentRiskTextCode,
                              AuditTrail: resultContent.autoLockRiskAnalysisData.auditTrail,
                              MatchedLegendTextCode: resultContent.autoLockRiskAnalysisData.matchedLegendTextCode,
                              CalculatedRiskType_Source: resultContent.autoLockRiskAnalysisData.calculatedRiskType_Source,
                              IsRiskAdjusted: resultContent.autoLockRiskAnalysisData.isRiskAdjusted,
                              AdjustedAlertType: resultContent.autoLockRiskAnalysisData.adjustedRiskLevel === 'Y' ? 'Yellow' : 'Red',
                              AlertReason: resultContent.autoLockRiskAnalysisData.alertReason
                            };


                            if (resultContent.enableRemovalRequest !== null && resultContent.enableRemovalRequest) {


                              if (destinationDetails.RequestStatus == 2) {
                                console.log('Access Control Notice will not be sent it is approved with status code:' + destinationDetails.RequestStatus);
                              }
                              else {
                                (async () => {
                                  await this.triggerDetectionAndNotifyAccess(this.destShortURL, resultContent.lockId, accessControlNoticeRequest, ipAddress);
                                })();
                              }
                              if (destinationDetails != null && destinationDetails.RequestStatus != null && destinationDetails.RequestsCount != null) {

                                if (destinationDetails.RequestStatus != 2) {

                                  const accessDecision: AccessDecision = {
                                    Id: destinationDetails.MessageId,
                                    Feature: this.featureType,

                                    Key: this.destShortURL,
                                    Count: destinationDetails.RequestsCount,
                                    Status: destinationDetails.RequestStatus,
                                    Lang: destinationDetails.MessageLanguage,
                                    RefUrl: this.protectedRefUrl,
                                    Theme: this.themeValue ? 'dark' : 'light',
                                    Source: 'protectedMessage',
                                    hashedLockId: resultContent.lockId,
                                    EMailDispatchOption: destinationDetails.EMailDispatchOption,
                                    PhoneNumber: destinationDetails.PhoneNumber,
                                    DestinationName: destinationDetails.DestinationName,
                                    SenderAddress: destinationDetails.SenderAddress,
                                    MessageSubject: destinationDetails.MessageSubject,
                                    DestinationAddress: destinationDetails.DestinationAddress

                                  };


                                  this.accessDecisionService.setAccessDecision(accessDecision);
                                  this.router.navigate(['/requestaccess/RD']);

                                }

                              }
                              if (destinationDetails != null && destinationDetails.RequestStatus == null && destinationDetails.RequestsCount == null) {
                                // console.log('Access Control Notice Sent:', AutoLockDecisionResponse.resultContent);
                                const accessDecision: AccessDecision = {
                                  Id: destinationDetails.MessageId,
                                  Feature: this.featureType,
                                  Key: this.destShortURL,
                                  Count: 0,
                                  Status: 0,
                                  Lang: destinationDetails.MessageLanguage,
                                  RefUrl: this.protectedRefUrl,
                                  Theme: this.themeValue ? 'dark' : 'light',
                                  Source: 'protectedMessage',
                                  hashedLockId: resultContent.lockId,
                                  EMailDispatchOption: destinationDetails.EMailDispatchOption,
                                  PhoneNumber: destinationDetails.PhoneNumber,
                                  DestinationName: destinationDetails.DestinationName,
                                  SenderAddress: destinationDetails.SenderAddress,
                                  MessageSubject: destinationDetails.MessageSubject,
                                  DestinationAddress: destinationDetails.DestinationAddress

                                };
                                console.log("themeValue =", this.themeValue);
                                console.log("Theme sent =", this.themeValue ? "dark" : "light");
                                this.accessDecisionService.setAccessDecision(accessDecision);

                                this.router.navigate(['/requestaccess/RD']);

                              }


                            }
                            else {
                              (async () => {
                                await this.triggerDetectionAndNotifyAccess(this.destShortURL, resultContent.lockId, accessControlNoticeRequest, ipAddress);
                              })();
                              this.isAutoLock_AccessDenied = true;
                              this.accessDeniedText = "Access Denied";
                              this.contactSenderText = "Please contact the sender for further information.";
                              this.isDisappearInk = false;

                              this.location.go(`/accessdenied/${this.destShortURL}` + "/RD");
                              return;

                            }

                            //this.router.navigateByUrl(`/accessdenied/${this.destShortURL}`+"/RD");



                          } else {
                            console.log('Access is allowed');
                            (async () => {
                              await this.triggerDetectionAndNotifyAccess(this.destShortURL, "", null, ipAddress);
                            })();
                            this.isAutoLock_AccessDenied = false;
                            this.accessDeniedText = "";
                            this.contactSenderText = "";
                            this.isDisappearInk = false;

                            this.getCountryDialCodeList();
                            this.loginForm = this.formBuilder.group({
                              emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]],
                            });
                            this.loginFormSMS = this.formBuilder.group({
                              phoneNumber: [null, [Validators.required, Validators.pattern(this.phoneNumberPattern)]],
                              countryDialCode: [null, [Validators.required]]
                            });
                          }
                          if (!resultContent.enabled) {
                            console.log('Autolock feature is not enabled');
                            (async () => {
                              await this.triggerDetectionAndNotifyAccess(this.destShortURL, "", null, ipAddress);
                            })();
                            this.isAutoLock_AccessDenied = false;
                            this.accessDeniedText = "";
                            this.contactSenderText = "";
                            this.isDisappearInk = false;

                            this.getCountryDialCodeList();
                            this.loginForm = this.formBuilder.group({
                              emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]],
                            });
                            this.loginFormSMS = this.formBuilder.group({
                              phoneNumber: [null, [Validators.required, Validators.pattern(this.phoneNumberPattern)]],
                              countryDialCode: [null, [Validators.required]]
                            });
                          }
                        }
                        else {
                          (async () => {
                            await this.triggerDetectionAndNotifyAccess(this.destShortURL, "", null, ipAddress);
                          })();
                          this.isAutoLock_AccessDenied = false;
                          this.accessDeniedText = "";
                          this.getCountryDialCodeList();
                          this.loginForm = this.formBuilder.group({
                            emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]],
                          });
                          this.loginFormSMS = this.formBuilder.group({
                            phoneNumber: [null, [Validators.required, Validators.pattern(this.phoneNumberPattern)]],
                            countryDialCode: [null, [Validators.required]]
                          });
                        }
                      },
                      error => {
                        console.error('Error during auto lock access check:', error);
                      }
                    );
                }
                else {
                  (async () => {
                    await this.triggerDetectionAndNotifyAccess(this.destShortURL, "", null, ipAddress);
                  })();
                  this.isAutoLock_AccessDenied = false;
                  this.accessDeniedText = "";
                  this.contactSenderText = "";
                  this.isDisappearInk = false;

                  this.getCountryDialCodeList();
                  this.loginForm = this.formBuilder.group({
                    emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]],
                  });
                  this.loginFormSMS = this.formBuilder.group({
                    phoneNumber: [null, [Validators.required, Validators.pattern(this.phoneNumberPattern)]],
                    countryDialCode: [null, [Validators.required]]
                  });
                }
              }
              else {
                (async () => {
                  await this.triggerDetectionAndNotifyAccess(this.destShortURL, "", null, ipAddress);
                })();
                this.isAutoLock_AccessDenied = false;
                this.accessDeniedText = "";
                this.getCountryDialCodeList();
                this.loginForm = this.formBuilder.group({
                  emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]],
                });
                this.loginFormSMS = this.formBuilder.group({
                  phoneNumber: [null, [Validators.required, Validators.pattern(this.phoneNumberPattern)]],
                  countryDialCode: [null, [Validators.required]]
                });
              }
 this.destinationLoaded = true;
              this.checkPageReady();
              this.cdRef.detectChanges();

            },

            error => {
              console.error('Error getting destination details:', error);
              this.destinationLoaded = true;
              this.checkPageReady();
            }
          );
      });
    });
    this.cdRef.detectChanges();
  }


  async triggerDetectionAndNotifyAccess(
    ShortURL: string,
    LockId: string,
    request: SendAccessControlNoticeRequestModel | null,
    ipAddress: string
  ): Promise<void> {
    //opendetection
    this.ActiveTabsKey = `pt_${this.destShortURL}_${ipAddress}`;
    this.detectionKey = `PTODT_${this.destShortURL}_${ipAddress}`;
    //autolock opendetection
    this.OpenActiveTabsKey = `opt_${this.destShortURL}_${ipAddress}`;
    this.OpendetectionKey = `OPTODT_${this.destShortURL}_${ipAddress}`;
    //autolock
    this.AutolockActiveTabsKey = `Apt_${this.destShortURL}`;
    this.AutolockDetectionKey = `APTODT_${this.destShortURL}`;
    var savedFingerprintDetails = false;
    //without autolock enabled
    if (!LockId && !request) {
      this.sessionState.setKeys(this.detectionKey, this.ActiveTabsKey);
      if (this.sessionState.isFirstVisit()) {
        this.sessionState.markVisited();

        if(this.IsDeviceFingerprintSettingEnabled)
        {
          savedFingerprintDetails = await this.saveFingerprintDetails();
        }
        else{
          savedFingerprintDetails = true;
        }
         if (savedFingerprintDetails) {
           await this.triggerOpenDetection(ShortURL);
         }
        // return;
      } else {
        console.log('Open detection already triggered or new tab — skipping.');
      }
    }
    //autolock enabled
    if (LockId && request) {
      this.sessionState.setKeys(this.OpendetectionKey, this.OpenActiveTabsKey);

      if (this.sessionState.isFirstVisit()) {
        this.sessionState.markVisited();
        const finalShortURL = `${ShortURL}@${LockId}`;

        if(this.IsDeviceFingerprintSettingEnabled)
        {
          savedFingerprintDetails = await this.saveFingerprintDetails();
        }
        else{
          savedFingerprintDetails = true;
        }
         if (savedFingerprintDetails) {
           await this.triggerOpenDetection(finalShortURL);
         }
        // return;
      } else {
        console.log('Open detection already triggered or new tab — skipping.');
      }
      this.AutolockSessionState.setKeys(this.AutolockActiveTabsKey, this.AutolockDetectionKey);
      if (this.AutolockSessionState.isFirstVisit()) {
        this.AutolockSessionState.markVisited();
         if (savedFingerprintDetails) {
        await this.sendAccessControlNotice(request);
         }
        // return;
      } else {
        console.log('sendAccessControlNotice already triggered or new tab — skipping.');
      }
    }
  }
  async triggerOpenDetection(id: string): Promise<void> {

    try {
if(!this.IsDeviceFingerprintSettingEnabled)
        {
          this.deviceLogId = "";
        }
      const success = await this.AI_Autolock_user
        .triggerOpenDetection(id, "protectedtext", this.deviceLogId)
        .toPromise();

      if (success) {
        console.log('Open detection triggered successfully');
      }
    }
    catch (error) {
      console.error('Error triggering open detection:', error);
    }
  }
  async saveFingerprintDetails(): Promise<boolean> {

    try {
      const encryptedFP = await (window as any) .collect();
      const success = await this.AI_Autolock_user.saveFingerprintDetails(this.deviceLogId, encryptedFP)
          .toPromise();

      if (success) {
         return true;
      }
       return false;
    }
    catch (error) {
       return true;
    }
  }
  async sendAccessControlNotice(request: SendAccessControlNoticeRequestModel): Promise<void> {
    try {
      const response = await this.AI_Autolock_user
        .sendAccessControlNotice(request)
        .toPromise();
      console.log('Access Control Notice Sent');
    }
    catch (error) {
      console.error('Error sending access control notice:', error);
    }
  }

  async detectClientInfo(): Promise<{ ipAddress: string, userAgent: string, referer: string, language: string }> {
    const serverVariables = await this.AI_Autolock_user.getServerVariables().toPromise();

    if (serverVariables) {
      const { IPAddress, UserAgent, Referer, BrowserLanguage } = serverVariables;
      return {
        ipAddress: IPAddress || null,
        userAgent: UserAgent || null,
        referer: Referer || null,
        language: BrowserLanguage || null
      };
    } else {
      return {
        ipAddress: null,
        userAgent: null,
        referer: null,
        language: null
      };
    }
  }
getBrandingDetails() {
  this.subs.sink = this.user.postUserInformation(this.destShortURL, "RD")
    .subscribe(resp => {
      if (!(resp instanceof AppError)) {
        const response = resp as IBrandDetailsHF;
        const result = response.ResultContent;
        this.brandDetails = result;

        if (this.brandDetails.Theme == 2) {
          this.themeValue = false;
          this.dynamicDivClass = 'main-wrapper-white';
        }
        else {
          this.themeValue = true;
          this.dynamicDivClass = 'main-wrapper-black';
        }

        localStorage.setItem('themeValue', JSON.stringify(this.themeValue));

        this.emailDispatchOption = this.brandDetails.EMailDispatchOption;
        this.isSMSOptionEnabled = this.emailDispatchOption == 2 ? true : false;

        if (this.isSMSOptionEnabled == true) {
          this.subs.sink = this.user.postCountryDialCodeForSenderAddress(this.destShortURL)
            .subscribe(resp => {
              if (!(resp instanceof AppError)) {
                const response = resp as ICountryDialCodeForSenderAddress;
                this.DialCodeForSenderAddress = response.DialCode;
              }
            });
        }

        if (this.brandDetails.LogoSrc == null || this.brandDetails.LogoSrc == "") {
          this.showLogo = false;
        }
        else {
          this.showLogo = true;
          this.companyLogoURL = this.brandDetails.LogoSrc;
        }
      }

      // ===== Loader =====
      this.themeLoaded = true;
      this.showSkeleton = true;
      this.brandingLoaded = true;
      this.checkPageReady();
    },
    error => {

      // ===== Loader on error =====
      this.themeLoaded = true;
      this.showSkeleton = true;
      this.brandingLoaded = true;
      this.checkPageReady();

      console.error(error);
    });
}

  EmailVerification(emailID: string, phoneNumber: string, countryDialCode: string) {

    this.subs.sink = this.user.postUserVerification(this.destShortURL, emailID, phoneNumber, countryDialCode, "PM")
      .subscribe(resp => {
        this.showContentLoader = true;
        if (!(resp instanceof AppError)) {
          const response = resp as IEmailVefifyHF;
          const result = response.ResultContent;
          this.emailVerfication = result;
          if (this.emailVerfication.Verified.toString() == "true") {
            if (result.ProtectedMsgSendPassCode) {
             localStorage.setItem('themeValue', JSON.stringify(this.themeValue));
localStorage.setItem('brandingDetails', JSON.stringify(this.brandDetails));
if(this.approvedByPasscode == true){
  this.router.navigate(['/verifypc', this.encryptedShortUrl])
}
else {

this.router.navigate(['/verifypc', this.destShortURL]);
}


return;

            }
            else {
              this.getRedactTextView();
             this.countDown = timer(0, this.tick)
    .subscribe(() => this.redact.TimeAllowed);

// Call only once
if (this.redact.TimeAllowed > 0) {
    this.subs.sink = this.user.apiRedactTextViewDuration(this.logoId)
        .subscribe();
}
              this.isVerified = true;
              this.cdRef.detectChanges();
            }
          }
          else {
            this.showContentLoader = false;
            this.validEmail = false;
            this.validNumber = false;
          }

          //     localStorage.setItem('disapperInk',null);
        }
      });

  }
  // getRedactTextView() {
  //   //     this.subs.sink = this.user.getRedactTextView(this.destShortURL)
  //   this.user.postRedactTextView(this.destShortURL)
  //     .subscribe(resp => {
  //       if (!(resp instanceof AppError)) {

  //         const response = resp as IRedactHF;
  //         var result = response.ResultContent;

  //         if ((result.ViewsLeft == "0") || (result.IsRedactExpired == true)) {
  //           // this.subscription.unsubscribe()
  //           // setTimeout(()=>  this.subscription.unsubscribe(), 2000);
  //           this.router.navigate(['viewRemaining'], { skipLocationChange: true });
  //         }
  //         if (result.resultContents) {
  //           try {
  //             const decodedHtml = this.decodeBase64Utf8(this.destinationDetailsForProtectedText.EmailBody || '');
  //             this.destinationDetailsForProtectedText.DestinationDetails.emailBody = decodedHtml;
  //             var html = this.getSafeHtml(decodedHtml);
  //             this.protectedEmailBody = html;
  //             this.cdRef.detectChanges();
  //             //result.resultContents[0].HtmlText = decodedHtml;
  //           } catch (e) {
  //             console.error('Base64 decode error:', e);
  //             result.resultContents.HtmlText = 'Error: Content could not be decoded';
  //           }
  //         }
  //         this.redact = result;
  //         this.copyImages = []; // Reset image array to avoid duplication
  //         //     localStorage.setItem('disapperInk',null);
  //         localStorage.setItem('redact', JSON.stringify(this.redact));

  //         if (this.redact.LogoSrc == null || this.redact.LogoSrc == "") {
  //           this.showLogo = false;
  //         }
  //         else {
  //           this.showLogo = true;
  //           this.companyLogoURL = this.redact.LogoSrc;
  //         }
  //         this.confidentialityStatement = this.redact.ConfidentialityStatement;
  //         //const source = interval(this.redact.TimeAllowed * 1000);
  //         const endTime = Date.now() + (this.redact.TimeAllowed * 1000);

  //         this.subscription = interval(250).subscribe(() => {
  //           const now = Date.now();
  //           const diff = endTime - now;

  //           const seconds = Math.ceil(diff / 1000);

  //           if (seconds !== this.remainingTime) {
  //             this.remainingTime = Math.max(0, seconds);
  //           }

  //           if (diff <= 0) {
  //             this.subscription.unsubscribe();
  //             this.redirectToTimeRemaining();
  //           }
  //         });
  //         this.redact.resultContents;
  //         //this.subscription = source.subscribe(val => this.redirectToTimeRemaining());

  //         let count: number = 1;
  //         for (var x in this.redact.resultContents) {

  //           if (this.redact.resultContents.Text == "Error: Content could not be decoded") {
  //             break;
  //           }

  //           let objredact: RedactReply;

  //           objredact = this.redact.resultContents[x];
  //           //   console.log(objredact.HtmlText.toString().replace("<o:p></o:p>",));
  //           // this.copyText = this.copyText.concat("Redacted Text ");
  //           // this.copyText = this.copyText.concat(count.toString());
  //           // this.copyText = this.copyText.concat(" :");
  //           // this.copyText = this.copyText.concat('\n');
  //           this.copyText = this.copyText.concat(objredact.Text.toString().split("<br/>").join("\n"));
  //           this.copyText = this.copyText.concat('\n');
  //           this.copyText = this.copyText.concat('\n');
  //           count = count + 1;
  //           // Extract and store all Base64 images

  //           //  if (objredact.HtmlText.includes('data:image')) {
  //           //    const imgMatches = objredact.HtmlText.match(/src=\"(data:image\/.*?;base64,.*?)\"/g);

  //           //   if (imgMatches) {
  //           //     this.copyText = this.copyText.concat('[Image Included]\n\n');
  //           //     // Store all images in order
  //           //     imgMatches.forEach(match => {
  //           //       const imgSrc = match.replace('src="', '').replace('"', '');
  //           //       this.copyImages.push(imgSrc);
  //           //     });
  //           //   }
  //           // }

  //         }
  //         this.translate.use(this.redact.Language);
  //         localStorage.setItem('Langauge', this.redact.Language);
  //         this.logoId = this.redact.LogId;
  //         if ((this.redact.ViewsLeft == "0") || (this.redact.IsRedactExpired == true)) {
  //           this.subscription.unsubscribe()
  //           // setTimeout(()=>  this.subscription.unsubscribe(), 2000);
  //           this.router.navigate(['viewRemaining'], { skipLocationChange: true });
  //         }
  //          this.showContentLoader = false;
  //         this.cdRef.detectChanges();
  //       }
  //     });

  // }
  getRedactTextView() {
  //     this.subs.sink = this.user.getRedactTextView(this.destShortURL)
  this.user.postRedactTextView(this.destShortURL)
    .subscribe(resp => {
      if (!(resp instanceof AppError)) {

        const response = resp as IRedactHF;
        var result = response.ResultContent;

        // Check Transaction Terminated from DestinationDetails
        if (this.destinationDetailsForProtectedText &&
            this.destinationDetailsForProtectedText.DestinationDetails &&
            this.destinationDetailsForProtectedText.DestinationDetails.TTDT != null &&
            this.destinationDetailsForProtectedText.DestinationDetails.TTDT != '') {

          if (this.subscription) {
            this.subscription.unsubscribe();
          }

          this.router.navigate(
            ['transactionTerminated'],
            { skipLocationChange: true }
          );
          return;
        }

        if ((result.ViewsLeft == "0") || (result.IsRedactExpired == true)) {
          // this.subscription.unsubscribe()
          // setTimeout(()=>  this.subscription.unsubscribe(), 2000);
          this.router.navigate(['viewRemaining'], { skipLocationChange: true });
          return;
        }

        if (result.resultContents) {
          try {
            const decodedHtml = this.decodeBase64Utf8(
              this.destinationDetailsForProtectedText.EmailBody || ''
            );

            this.destinationDetailsForProtectedText.DestinationDetails.emailBody =
              decodedHtml;

            var html = this.getSafeHtml(decodedHtml);
            this.protectedEmailBody = html;
            this.cdRef.detectChanges();

            //result.resultContents[0].HtmlText = decodedHtml;
          } catch (e) {
            console.error('Base64 decode error:', e);
            result.resultContents.HtmlText =
              'Error: Content could not be decoded';
          }
        }

        this.redact = result;
        this.copyImages = []; // Reset image array to avoid duplication

        localStorage.setItem(
          'redact',
          JSON.stringify(this.redact)
        );

        if (this.redact.LogoSrc == null || this.redact.LogoSrc == "") {
          this.showLogo = false;
        }
        else {
          this.showLogo = true;
          this.companyLogoURL = this.redact.LogoSrc;
        }

        this.confidentialityStatement =
          this.redact.ConfidentialityStatement;

        //const source = interval(this.redact.TimeAllowed * 1000);
        const endTime =
          Date.now() + (this.redact.TimeAllowed * 1000);

        this.subscription = interval(250).subscribe(() => {
          const now = Date.now();
          const diff = endTime - now;

          const seconds = Math.ceil(diff / 1000);

          if (seconds !== this.remainingTime) {
            this.remainingTime = Math.max(0, seconds);
          }

          if (diff <= 0) {
            this.subscription.unsubscribe();
            this.redirectToTimeRemaining();
          }
        });

        this.redact.resultContents;

        //this.subscription = source.subscribe(val => this.redirectToTimeRemaining());

        let count: number = 1;

        for (var x in this.redact.resultContents) {

          if (
            this.redact.resultContents.Text ==
            "Error: Content could not be decoded"
          ) {
            break;
          }

          let objredact: RedactReply;

          objredact = this.redact.resultContents[x];

          //   console.log(objredact.HtmlText.toString().replace("<o:p></o:p>",));
          // this.copyText = this.copyText.concat("Redacted Text ");
          // this.copyText = this.copyText.concat(count.toString());
          // this.copyText = this.copyText.concat(" :");
          // this.copyText = this.copyText.concat('\n');
          this.copyText = this.copyText.concat(
            objredact.Text.toString().split("<br/>").join("\n")
          );

          this.copyText = this.copyText.concat('\n');
          this.copyText = this.copyText.concat('\n');

          count = count + 1;

          // Extract and store all Base64 images

          //  if (objredact.HtmlText.includes('data:image')) {
          //    const imgMatches = objredact.HtmlText.match(/src=\"(data:image\/.*?;base64,.*?)\"/g);

          //   if (imgMatches) {
          //     this.copyText = this.copyText.concat('[Image Included]\n\n');
          //     // Store all images in order
          //     imgMatches.forEach(match => {
          //       const imgSrc = match.replace('src="', '').replace('"', '');
          //       this.copyImages.push(imgSrc);
          //     });
          //   }
          // }

        }

        this.translate.use(this.redact.Language);
        localStorage.setItem('Langauge', this.redact.Language);

        this.logoId = this.redact.LogId;

        if (
          (this.redact.ViewsLeft == "0") ||
          (this.redact.IsRedactExpired == true)
        ) {
          this.subscription.unsubscribe();

          // setTimeout(()=>  this.subscription.unsubscribe(), 2000);

          this.router.navigate(
            ['viewRemaining'],
            { skipLocationChange: true }
          );
        }

        this.showContentLoader = false;
        this.cdRef.detectChanges();
      }
    });
}
  getCountryDialCodeList() {
    this.subs.sink = this.user.getCountryDialCodeList()
      .subscribe(resp => {
        if (!(resp instanceof AppError)) {
          const response = resp as ICountryCodeDetails;
          // const result = response.ResultContent;
          this.countryCodeDetails = response;
        }
      })

  }
  formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' + secs : secs}`;
  }

  redirectToTimeRemaining() {
    // setTimeout(()=>  this.subscription.unsubscribe(), 2000);
    this.router.navigate(['timeRemaining'], { skipLocationChange: true });
  }
  validEmail: boolean = true;
  validNumber: boolean = true;
  public copyText: string = "";
  verifyEmail(form: FormGroup) {
    if (this.loginForm.invalid) {

      if (this.loginForm.controls.emailId.errors)
        this.validEmail = false;
      return;
    }
    this.validEmail = true;
    let email = this.loginForm.controls.emailId.value;
    let phoneNumber = null;
    let countryDialCode = null;
    this.EmailVerification(email.toString(), phoneNumber, countryDialCode);
  }
  verifyNumber(form: FormGroup) {
    if (this.loginFormSMS.invalid) {

      if (this.loginFormSMS.controls.phoneNumber.errors || this.loginFormSMS.controls.countryDialCode.errors) {
        this.validNumber = false;
      }
      return;
    }

    this.validNumber = true;
    let email = null;
    let phoneNumber = this.loginFormSMS.controls.phoneNumber.value;
    let countryDialCode = this.loginFormSMS.controls.countryDialCode.value;
    this.EmailVerification(email, phoneNumber.toString(), countryDialCode.toString());

  }

  // copyMessage() {
  //   const selBox = document.createElement('textarea');
  //   selBox.style.position = 'fixed';
  //   selBox.style.left = '0';
  //   selBox.style.top = '0';
  //   selBox.style.opacity = '0';
  //   selBox.value = this.copyText;
  //   document.body.appendChild(selBox);
  //   selBox.focus();
  //   selBox.select();
  //   document.execCommand('copy');
  //   document.body.removeChild(selBox);
  //   this.copied = true;
  //   setTimeout(() => {                           //<<<---using ()=> syntax
  //     this.copied = false;
  //   }, 3000);
  // }

  //   ngOnDestroy() {
  //     this.subscription.unsubscribe()
  // }
  async copyMessage() {
    try {
      // Build HTML content with images in correct positions
      let htmlContent = this.decodeBase64Utf8(
        this.destinationDetailsForProtectedText.EmailBody || ''
      );
      // let plainText = this.copyText;
      let plainText = this.htmlToPlainText(htmlContent);
      let currentImageIndex = 0;

      // Split text by image markers and insert actual images
      // const textSegments = this.copyText.split('[Image Included]');

      // textSegments.forEach((segment, index) => {
      //     htmlContent += segment;

      //     // Insert image if available and we're not at the last segment
      //     if (index < textSegments.length+1 && this.copyImages[currentImageIndex]) {
      //         htmlContent += `<img src="${this.copyImages[currentImageIndex]}" style="max-width: 300px;">`;
      //         currentImageIndex++;
      //     }
      // });

      // Create clipboard items
      const clipboardItems = [];
      const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
      const textBlob = new Blob([plainText], { type: 'text/plain' });

      // Add both formats to clipboard
      clipboardItems.push(
        new (window as any).ClipboardItem({
          'text/html': htmlBlob,
          'text/plain': textBlob
        })
      );

      // Write to clipboard
      await (navigator.clipboard as any).write(clipboardItems);
      console.log('All content copied to clipboard successfully');
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 3000);

    } catch (err) {
      console.error('Failed to copy content: ', err);

      // Fallback 1: Try copying just text
      try {
        await navigator.clipboard.writeText(this.copyText);
        console.log('Text copied successfully (fallback)');
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 3000);
      } catch (textErr) {
        console.error('Failed to copy text: ', textErr);
      }

      // Fallback 2: Provide image downloads
      this.copyImages.forEach((img, index) => {
        const link = document.createElement('a');
        link.href = img;
        link.download = `image_${index + 1}.png`;
        link.click();
        console.log(`Image ${index + 1} download triggered`);
      });
    }
  }

  htmlToPlainText(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || '';
  }
  sanitizeHtml(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  private checkPageReady(): void {

    if (this.brandingLoaded && this.destinationLoaded) {

        this.loading = false;

    }

}

  toggleReply() {
    this.isReplyOpen = !this.isReplyOpen;

    if (this.isReplyOpen) {
      this.isExpanded = true; // open by default when reply clicked
      this.scrollToReplySection();
    } else {
      this.scrollToMessageSection();
    }
  }

 acceptReply() {
  this.isEsignOneClickReplyOpen = !this.isEsignOneClickReplyOpen;

  if (this.isEsignOneClickReplyOpen) {
    this.isExpanded = true;
    this.scrollToReplySection();
  } else {
    this.scrollToMessageSection();
  }
}

  scrollToReplySection() {
    setTimeout(() => {
      if (this.replySection && this.replySection.nativeElement) {
        const replyElement = this.replySection.nativeElement as HTMLElement;
        const footerElement = document.querySelector('.branding-footer') as HTMLElement;
        const footerHeight = footerElement ? footerElement.getBoundingClientRect().height : 0;
        const replyBottom = window.pageYOffset + replyElement.getBoundingClientRect().bottom;
        const scrollTop = replyBottom - window.innerHeight + footerHeight + 20;

        window.scrollTo({
          top: Math.max(scrollTop, 0),
          behavior: 'smooth',
        });
      }
    }, 100);
  }

  scrollToMessageSection() {
    setTimeout(() => {
      if (this.messageSection && this.messageSection.nativeElement) {
        this.messageSection.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  }

  popupCloseEvent(event: any) {
    if (event == eventType.PopUpCLose.toString()) {
      this.isEsignOneClickReplyOpen = false;
      this.isReplyOpen = false;
      this.scrollToMessageSection();
      return;
    }
    if (event == eventType.ErrorReply.toString()) {
      this.showErrorToasterMsg('Error occured while sending reply message.');
      return;
    }
    if (event == eventType.SuccessEsignReply.toString()) {
      this.isEsignOneClickReplyOpen = false;
      //this.isReplyOpen = false;
      this.destinationDetailsForProtectedText.DestinationDetails.IsSigned = 1;
      return;
    }
    if (event == eventType.SuccessProtectedReply.toString()) {
      //this.isEsignOneClickReplyOpen = true;
      this.getRemainingReplyCount();
      this.isReplyOpen = false;
      this.scrollToMessageSection();
      return;
    }
  }

  getRemainingReplyCount() {

    this.destinationDetailsForProtectedText.DestinationDetails.ProtectMsgReplyLimit--;
  }

  toggleAccordion() {
    this.isExpanded = !this.isExpanded;
  }
  toggleSidebar(event: Event) {
  event.stopPropagation();

  this.showAttachmentPane = !this.showAttachmentPane;

  if (this.showAttachmentPane && this.attachments.length > 0) {
    this.dynamicDivClass = this.themeValue
      ? 'main-wrapper-black right-sidebar-active'
      : 'main-wrapper-white right-sidebar-active';
  } else {
    this.dynamicDivClass = this.themeValue
      ? 'main-wrapper-black'
      : 'main-wrapper-white';
  }

  if (this.showAttachmentPane && this.attachments.length === 0) {

    console.log('Loading attachments for short URL:', this.destShortURL);

    if (this.destShortURL) {

      this.user.getAttachments(this.destShortURL).subscribe({
        next: (res: any[]) => {
          console.log('Attachments response:', res);
          this.attachments = res || [];
        },

        error: (err) => {
          console.error('Attachment load error:', err);
          this.attachments = [];
        }
      });

    } else {
      console.error('Short URL not available');
    }
  }
}

 // downloadAttachment(file: any) {

  //   this.user.downloadAttachment(
  //     file.Id,
  //     this.destinationDetailsForProtectedText
  //       .DestinationDetails.MessageCategory,
  //     file.FileName
  //   ).subscribe({

  //     next: (blob: Blob) => {

  //       const url = window.URL.createObjectURL(blob);

  //       const a = document.createElement('a');

  //       a.href = url;
  //       a.download = file.FileName;

  //       a.click();

  //       window.URL.revokeObjectURL(url);

  //       // UI update only

  //       file.DownloadedCount =
  //         (file.DownloadedCount || 0) + 1;

  //       if (
  //         file.ProtectMsgAttachmentDownloadLimit > 0 &&
  //         file.DownloadedCount >=
  //         file.ProtectMsgAttachmentDownloadLimit
  //       ) {

  //         file.ShowDownloadButton = false;

  //         // refresh UI immediately
  //         this.attachments = [...this.attachments];
  //       }
  //     },

  //     error: (err) => {

  //       console.error('Download failed', err);
  //     }
  //   });
  // }
downloadAttachment(file: any) {

  this.user.downloadAttachment(file.Id).subscribe({

    next: (blob: Blob) => {

      // Transaction terminated response
      if (blob.type.indexOf('application/json') !== -1) {

        const reader = new FileReader();

        reader.onload = () => {
          try {

            const response = JSON.parse(reader.result as string);

            if (response.TTDT === true) {
              this.router.navigate(
                ['transactionTerminated'],
                { skipLocationChange: true }
              );
              return;
            }

          } catch (e) {
            console.error(
              'Unable to parse download response',
              e
            );
          }
        };

        reader.readAsText(blob);
        return;
      }

      // Normal file download
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');

      a.href = url;
      a.download = file.FileName;

      a.click();

      window.URL.revokeObjectURL(url);

      // Update download count
      file.DownloadedCount =
        (file.DownloadedCount || 0) + 1;

      if (
        file.ProtectMsgAttachmentDownloadLimit > 0 &&
        file.DownloadedCount >=
          file.ProtectMsgAttachmentDownloadLimit
      ) {

        file.ShowDownloadButton = false;

        this.attachments = [...this.attachments];
      }
    },

    error: (err) => {
      console.error('Download failed', err);
    }
  });
}
  // downloadZip() {

  //   const details =
  //     this.destinationDetailsForProtectedText
  //       .DestinationDetails;

  //   this.user.downloadZip(
  //     details.MessageId,
  //     details.MessageCategory
  //   )
  //     .subscribe({

  //       next: (blob: Blob) => {

  //         const downloadUrl =
  //           window.URL.createObjectURL(blob);

  //         const a =
  //           document.createElement('a');

  //         a.href = downloadUrl;

  //         a.download = 'Attachments.zip';

  //         a.click();

  //         window.URL.revokeObjectURL(downloadUrl);

  //         console.log('ZIP downloaded successfully');

  //         // UPDATE ATTACHMENT COUNTS IMMEDIATELY
  //         this.attachments.forEach(file => {

  //           file.DownloadedCount =
  //             (file.DownloadedCount || 0) + 1;

  //           if (
  //             file.ProtectMsgAttachmentDownloadLimit > 0 &&
  //             file.DownloadedCount >=
  //             file.ProtectMsgAttachmentDownloadLimit
  //           ) {

  //             file.ShowDownloadButton = false;
  //           }
  //         });

  //         // Hide ZIP button also if all files reached limit
  //         this.attachments = [...this.attachments];
  //       },

  //       error: (err) => {

  //         console.error('ZIP download failed', err);
  //       }
  //     });
  // }
downloadZip() {

  const details =
    this.destinationDetailsForProtectedText.DestinationDetails;

  this.user.downloadZip(
    details.MessageId,
    details.MessageCategory
  ).subscribe({
    next: (blob: Blob) => {

      if (blob.type.indexOf('application/json') !== -1) {

        const reader = new FileReader();

        reader.onload = () => {
          try {

            const response = JSON.parse(
              reader.result as string
            );

            if (response.TTDT === true) {

              this.router.navigate(
                ['transactionTerminated'],
                { skipLocationChange: true }
              );

              return;
            }

          } catch (e) {
            console.error(
              'Unable to parse ZIP response',
              e
            );
          }
        };

        reader.readAsText(blob);
        return;
      }

      // Normal ZIP download
      const downloadUrl =
        window.URL.createObjectURL(blob);

      const a = document.createElement('a');

      a.href = downloadUrl;
      a.download = 'Attachments.zip';

      a.click();

      window.URL.revokeObjectURL(downloadUrl);

      // Update attachment counts
      this.attachments.forEach(file => {

        file.DownloadedCount =
          (file.DownloadedCount || 0) + 1;

        if (
          file.ProtectMsgAttachmentDownloadLimit > 0 &&
          file.DownloadedCount >=
            file.ProtectMsgAttachmentDownloadLimit
        ) {
          file.ShowDownloadButton = false;
        }

      });

      this.attachments = [...this.attachments];
    },

    error: (err) => {
      console.error('ZIP download failed', err);
    }
  });
}
  hasDownloadableFiles(): boolean {

    if (!this.attachments || this.attachments.length === 0) {
      return false;
    }

    return this.attachments.some(function (file) {
      return file.ShowDownloadButton;
    });
  }

  // santizeDecodedHTML(htmlBody: any) {
  //   if (!htmlBody) return '';

  //   return htmlBody

  //     // remove ONLY#ffffff and#f0f0f0 backgrounds -removing the bgcolors from innerhtml
  //     .replace(/background(-color)?\s*:\s*(#ffffff|#fff|#f0f0f0)[^;"]*;?/gi, '')

  //     // remove bgcolor attribute only if those colors
  //     .replace(/bgcolor="(#ffffff|#fff|#f0f0f0)"/gi, '')

  //     // replace standalone color usage
  //     .replace(/#ffffff|#fff|#f0f0f0/gi, 'transparent')

  //     // cleanup encoding
  //     .replace(/\u00A0/g, ' ')
  //     .replace(/Â/g, '')
  //     .replace(/(^|>)([^<]*)(https:\/\/[^\s<]+)/gi,
  //      (m, start, text, url) =>
  //     `${start}${text}<a href="${url}" style="color:#007bff !important;text-decoration:underline !important;">${url}</a>`
  // )
  //     .trim();
  // }

  getSafeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.santizeDecodedHTML(html)
    );
  }

  santizeDecodedHTML(htmlBody: any) {
    if (!htmlBody) return '';

    let processedHtml = htmlBody;

    // Remove full document wrappers
    processedHtml = processedHtml
      .replace(/<!DOCTYPE[^>]*>/gi, '')
      .replace(/<html[^>]*>/gi, '')
      .replace(/<\/html>/gi, '')
      .replace(/<head[\s\S]*?<\/head>/gi, '')
      .replace(/<body[^>]*>/gi, '')
      .replace(/<\/body>/gi, '');

    // Remove MS Word tags
    processedHtml = processedHtml
      .replace(/<o:p>\s*<\/o:p>/gi, '')
      .replace(/<o:p>.*?<\/o:p>/gi, '&nbsp;')
      .replace(/\s*mso-[^:]+:[^;"]+;?/gi, '')
      .replace(/\s*tab-stops:[^;"]*;?/gi, '')
      .replace(/\s*font-variant-ligatures:[^;"]*;?/gi, '');

    // Remove styles/scripts/meta/link
    processedHtml = processedHtml
      .replace(/<style[\s\S]*?<\/style>/gi, '')
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/<meta[^>]*>/gi, '')
      .replace(/<link[^>]*>/gi, '');

    // Remove comments
    processedHtml = processedHtml
      .replace(/<!--[\s\S]*?-->/gi, '');

    // Cleanup encoding
    processedHtml = processedHtml
      .replace(/\u00A0/g, ' ')
      .replace(/Â/g, '');

    // Remove empty tags
    // processedHtml = processedHtml
    //   .replace(/<[^\/>][^>]*>\s*<\/[^>]+>/g, '');
    processedHtml = processedHtml.replace(
      /<([a-z][a-z0-9]*)\b[^>]*>\s*<\/\1>/gi,
      ''
    );

    // Convert plain URLs to clickable links
    processedHtml = processedHtml.replace(
      /(^|>)([^<]*)(https:\/\/[^\s<]+)/gi,
      (m: any, start: any, text: any, url: any) =>
        `${start}${text}<a href="${url}" target="_blank"
      style="color:#007bff;text-decoration:underline">${url}</a>`
    );

     // Theme handling

  // Dark theme: convert dark/black text to white
    // Theme handling: one DOM pass for both themes, then write the result back.
    {
      const doc = new DOMParser().parseFromString(processedHtml, 'text/html');
      const textColor = this.themeValue ? '#ffffff' : '#000000';
      const linkColor = this.themeValue ? '#4da3ff' : '#007bff';

      const isWhite = (v: string) =>
        /^(#fff(fff)?|white|rgba?\(\s*255\s*,\s*255\s*,\s*255\s*(,\s*1(\.0+)?\s*)?\))$/i.test(v.trim());

      doc.body.querySelectorAll<HTMLElement>('*').forEach(el => {
        // 1. white backgrounds -> drop them so the container shows through
        const bg = el.style.backgroundColor || el.style.background;
        const hasNonWhiteBg = !!bg && !isWhite(bg);
        if (bg && isWhite(bg)) {
          el.style.removeProperty('background-color');
          el.style.removeProperty('background');
        }
        if (el.hasAttribute('bgcolor') && isWhite(el.getAttribute('bgcolor') || '')) {
          el.removeAttribute('bgcolor');
        }

        // 2. text color; links get their own colour, buttons (a link with its
        // own background, e.g. "View & Sign Document") keep their own styling
        if (el.tagName === 'A') {
          if (!hasNonWhiteBg) {
            el.style.setProperty('color', linkColor, 'important');
            el.style.setProperty('text-decoration', 'underline', 'important');
          }
        } else {
          el.style.setProperty('color', textColor, 'important');
        }
      });

      doc.body.querySelectorAll<HTMLElement>('[bgcolor="#F0F0F0"]').forEach(el => {
  el.removeAttribute('bgcolor');
});
      processedHtml = doc.body.innerHTML;
    }

    processedHtml = processedHtml.replace(
  /background(?:-color)?\s*:\s*(#ffffff|#fff|white)\s*;?/gi,
  '');
   processedHtml = processedHtml.replace(
  /(Download Password[\s\S]*?<td[^>]*>)([^<]+)(<\/td>)/i,
  `$1<span style="
  background:#FFFF00;
  color:#000000 !important;
  font-family:Verdana;
  font-weight:600;
  padding:2px 6px;
  display:inline-block;
  line-height:1.2;
  margin-bottom:8px;
">$2</span>$3`
);
    const themeClass = this.themeValue
      ? 'dark-theme'
      : 'light-theme';

    processedHtml = processedHtml
      .replace(/<table/gi, `<table class="${themeClass}"`);


    processedHtml = processedHtml.replace(
      /\sbgcolor=['"](#ffffff|#fff|white)['"]/gi,
      ''
    );

    processedHtml = processedHtml.replace(
      /(<table[^>]*style=")([^"]*border\s*:\s*5px\s+solid\s+#ffcc00;?[^"]*)(")/gi,
      (_match: string, start: string, styles: string, end: string) => {
        if (/background-color/i.test(styles)) {
          return `${start}${styles}${end}`;
        }

        return `${start}${styles}; background-color:#ffcc00;${end}`;
      }


    );
    // Make "Download Files" link appear as a yellow button
processedHtml = processedHtml.replace(
  /<a([^>]*?)style=['"]([^'"]*)['"]([^>]*)>(\s*Download\s+Files\s*)<\/a>/gi,
  `<a$1style="$2;
      background:#ffcc00;
      color:#000000 !important;
      display:inline-block;
      padding:4px 20px;
      font-weight:bold;
      text-decoration:none;
      border:1px solid #ffcc00;
      border-radius:0;
      white-space:nowrap;
      min-width:150px;
      text-align:center;
      box-sizing:border-box;"$3>Download Files</a>`
);

    // Make "View & Sign Document" link appear as a yellow button
processedHtml = processedHtml.replace(
  /<a([^>]*?)(?:\sstyle=['"][^'"]*['"])?([^>]*)>(\s*View\s*(?:&amp;|&)\s*Sign\s+Document\s*)<\/a>/gi,
  (_match: string, before: string, after: string, text: string) =>
    `<a${before}${after} style="
      background:#ffcc00;
      color:#000000 !important;
      display:inline-block;
      padding:4px 20px;
      font-weight:bold;
      text-decoration:none;
      border:1px solid #ffcc00;
      border-radius:0;
      white-space:nowrap;
      min-width:150px;
      text-align:center;
      box-sizing:border-box;">${text}</a>`
);

    return processedHtml.trim();
  }

  decodeBase64Utf8(base64: string): string {
    try {
      return decodeURIComponent(
        Array.prototype.map.call(atob(base64), (c: string) => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join('')
      );
    } catch (e) {
      console.error('UTF-8 decode failed', e);
      return atob(base64); // fallback
    }
  }

  // loadAttachments() {

  //   const msgId =
  //     this.destinationDetailsForProtectedText.DestinationDetails.MessageId;

  //   const category = this.destinationDetailsForProtectedText.DestinationDetails.MessageCategory;

  //   const destinationId = this.destinationDetailsForProtectedText.DestinationDetails.DestinationId;

  //   this.user.getAttachments(msgId, category, destinationId
  //   )
  //     .subscribe({

  //       next: (res: any) => {

  //         this.attachments = res || [];

  //       },

  //       error: (err) => {

  //         console.error(
  //           'Attachment refresh failed',
  //           err
  //         );
  //       }
  //     });
  // }
  ngOnDestroy(): void {
    // Emit a value to complete all subscriptions
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  showSuccessToasterMsg(msg: string) {

    this.snackBar.open(msg, 'Close', {
      duration: 30000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['success-snackbar']
    });
  }

  showErrorToasterMsg(message: string) {
    this.snackBar.open(message, 'Close', {
      duration: 300000,
      //horizontalPosition: 'right',
      //verticalPosition: 'top',
      panelClass: ['error-snackbar', 'snack']
    });
  }

}
